import React, { useEffect, useState, useMemo } from "react";
import { Card, CardBody, CardHeader, Col, Table, Badge, Input } from "reactstrap";
import { listAllPausedSubscription } from "../Subscription/_requests";
import { formatDate } from "../../helpers/FunctionHelpers";
import moment from "moment";

const PausedSubscriptions = () => {
    const [subscriptions, setSubscriptions] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));

    useEffect(() => {
        const fetchSubscriptions = async () => {
            setIsLoading(true);
            try {
                const res: any = await listAllPausedSubscription();
                console.log("listAllPausedSubscription", res);
                setSubscriptions(res.data || []);
            } catch (error) {
                console.error("Error fetching subscriptions for paused list:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchSubscriptions();
    }, []);
    console.log("subscriptions", subscriptions);
    const filteredSubscriptions = useMemo(() => {
        return subscriptions.filter((item: any) => {
            console.log(" listAllPausedSubscription", item);
            // Adjust based on the actual date field returned by API
            const pausedDate = item.date
            if (!pausedDate) return false;
            return moment(pausedDate).format("YYYY-MM-DD") === selectedDate;
        });
    }, [subscriptions, selectedDate]);

    return (
        <React.Fragment>
            <Col xl={12}>
                <Card>
                    <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Paused Subscriptions</h4>
                        <div className="flex-shrink-0">
                            <Input
                                type="date"
                                className="form-control-sm"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                        </div>
                    </CardHeader>
                    <CardBody>
                        <div className="table-responsive">
                            <Table className="align-middle table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>User</th>
                                        <th>Plan</th>
                                        <th>Product Details</th>
                                        <th>Paused On</th>
                                        <th className="text-center">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredSubscriptions.length > 0 ? (
                                        filteredSubscriptions.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <h6 className="fs-14 mb-1">{item.user?.name || "Unknown"}</h6>
                                                            <p className="text-muted mb-0">{item.user?.mobile_number}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{item?.userSubscription?.subscription?.name}</td>
                                                <td>
                                                    {item?.userSubscription?.details?.map((detail: any, idx: number) => (
                                                        <div key={idx} className="small">
                                                            {detail.product?.name} ({detail.variant_value} {detail.variant?.name})
                                                        </div>
                                                    ))}
                                                </td>
                                                <td>{item.date ? formatDate(item.date) : "N/A"}</td>
                                                <td className="text-center">
                                                    <Badge color="warning" className="text-uppercase">Paused</Badge>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center text-muted py-4">
                                                No paused subscriptions found for this date.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default PausedSubscriptions;
